import { EImportSectionsTarget } from '@constants';
import { Flex, Input } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ComplementaryMaterial } from '../ComplementaryMaterial';
import { Introduction } from '../Introduction';
import { LiveRecords } from '../LiveRecords';
import { Material } from '../Material';
import { Sections } from '../Sections';

import { HeaderWrapper, TitleWrapper, Wrapper } from './Content.styles';

import { AddSection } from '@/components/AddSection';
import { ImportSection } from '@/components/SectionManagement';
import { useSearchSections } from '@/hooks';
import { useLocalCourse, useProfile } from '@/store';
import { ECourseContentStep } from '@/types';

export const Content = () => {
  const {
    roleCheck: { isManager }
  } = useProfile();
  const { search } = useLocation();
  const { course } = useLocalCourse();
  const { t } = useTranslation('CourseTranslations');
  const { searchValue, setSearchValue, filteredSections } = useSearchSections(
    course?.sections || []
  );
  const activeContentTab =
    new URLSearchParams(search).get('contentTab') ?? ECourseContentStep.SECTIONS;

  const title = useMemo(
    () =>
      activeContentTab === ECourseContentStep.COMPLEMENTARY_MATERIAL &&
      course?.complementaryMaterial?.title
        ? course.complementaryMaterial.title
        : t(activeContentTab as ECourseContentStep),
    [activeContentTab, course]
  );

  if (!course) return null;

  return (
    <Wrapper>
      <HeaderWrapper vertical gap={16}>
        <TitleWrapper>{title}</TitleWrapper>

        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
          <Flex style={{ width: '100%' }}>
            {activeContentTab === ECourseContentStep.SECTIONS && course.sections.length > 0 && (
              <Input.Search
                placeholder={t('SEARCH_SECTIONS_OR_ACTIVITIES_BY_NAME')}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                allowClear
                style={{ width: '100%', maxWidth: 400 }}
              />
            )}
          </Flex>

          <Flex gap={16}>
            {isManager &&
              activeContentTab === ECourseContentStep.SECTIONS &&
              course.sections.length > 0 && <AddSection course={course} />}

            {course.sections.length > 0 && activeContentTab === ECourseContentStep.SECTIONS && (
              <ImportSection target={EImportSectionsTarget.SECTIONS} fetchOnlyParentsCourses />
            )}
          </Flex>
        </Flex>
      </HeaderWrapper>

      {activeContentTab === ECourseContentStep.SECTIONS && <Sections sections={filteredSections} />}
      {activeContentTab === ECourseContentStep.INTRODUCTION && <Introduction />}
      {activeContentTab === ECourseContentStep.COMPLEMENTARY_MATERIAL && <ComplementaryMaterial />}
      {activeContentTab === ECourseContentStep.MATERIAL && <Material />}
      {activeContentTab === ECourseContentStep.RECORDED_CLASSES && <LiveRecords />}
    </Wrapper>
  );
};
